import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import {Box} from '@buncha/components/core/view';
import {CustomText} from '@buncha/components/core/text';
import React from 'react';
import {styles} from './styles';

interface OrderIdPillProps {
  text: string;
}

const OrderIdPill: React.FC<OrderIdPillProps> = props => {
  const {text} = props;
  const theme = useColorThemeType();
  const muliFont = useFontTheme('muli');
  return (
    <Box
      style={[
        styles.container,
        {
          backgroundColor: theme?.background.gray[200],
        },
      ]}>
      <CustomText
        style={{
          color: theme?.text.gray[100],
          fontFamily: muliFont[700].normal,
        }}>
        {text}
      </CustomText>
    </Box>
  );
};

export default React.memo(OrderIdPill);
